var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 6.167a.75.75 0 0 0-1.06 0L5.166 11.47a.75.75 0 0 0 0 1.06l5.304 5.304a.75.75 0 1 0 1.06-1.06L6.757 12l4.773-4.773a.75.75 0 0 0 0-1.061Z",
    fill: "#09205D"
  })));
};

export default SvgArrowLeft;